<script lang="ts">
	import { format } from 'svelte-i18n';
	// Design system
	import { Alert } from '@Shelly/shelly-design-system/index';
	//Components
	import TemplateToggleSettings from '../../Components/TemplateToggleSettings.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateToggleSettings
	class="mb-s"
	{device}
	setting="auto_charge"
	title={$format('enable', { default: 'Enable' })}
/>

<Alert
	heading={$format('ev_charger_auto_balance_enabled', {
		default:
			'When this feature is enabled, it will always start the charging process when the gun is connected to a car.',
	})}
/>
